export default Object.freeze({
  Ink: "#282828",
  Sky: "#0071AE",
  Midnight: "#143B66",
  Mist: "#C6C5C5",
  Orange: "#F4962B",
});



// WEBPACK FOOTER //
// ./src/core/admin/components/styled/colors.js